module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about-worth.json
// module id = 492
// module chunks = 256454709338522